import {Avatar, Image, Statistic} from 'antd'
import getAvatar from 'helpers/getAvatar'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import {useAppConfig} from 'modules/local'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {BiSolidChurch} from 'react-icons/bi'
import {Link} from 'react-router-dom'
import {CustomEditorRenderer} from 'views/AppLocals/custom/CustomRichEditor'
import {NullAsDefault, renderElse, renderIf} from 'views/Shared'
import {isRawContentEmpty} from 'views/SlateEditor/functions/parseRawContent'
import {HeaderWithIconLine} from '../../../Templates/items/ListHeader'
import CourseContext from '../../CourseContext'
import CourseClassTab from './CourseClassTab'
import CourseSubjectTab from './CourseSubjectTab'
import {ImagePlaceholder} from "../../../../../conts/imageBase64";
import {renderIfElse} from "../../../../Shared";
import {GiIronCross} from "react-icons/gi";
import {GoDotFill} from "react-icons/go";
import {LayoutContext} from "../../../../../components/layouts/Default/LayoutContext";
import {BsInfoCircle} from "react-icons/bs";
import TooltipApp from "components/TooltipApp";
import {copyLink} from "../../../../../helpers";
import {getAbsoluteLinkToDetail} from "../../../../../helpers/getLinkToDetail";
import {truncateMiddle} from "../../../../../helpers/stringUtils";
import {QRComponent} from "../../../custom/QRComponent";
import {IoIosCopy} from "react-icons/io";
import {DoubleValueItem} from "../../../CatholicHousehold/components/CatholicHouseholdComponents";
import {formatDate} from "../../../../../helpers/datetimeHelpers";
import {HiViewfinderCircle} from "react-icons/hi2";
import {formatSimplifyDate} from "../../../../../helpers/dateUtils";

const {Countdown} = Statistic


const ItemInformation = ({label, value, newLine = false}) => (
    <Translate>
        {(t) => renderIfElse(newLine,
            <div className="flex flex-col gap-1">
                <span className="text-color-500 flex items-center gap-1 text-sm italic">{`${t(label)} : `}</span>
                <span className="ml-2 font-bold text-color-100 flex items-center gap-1 text-sm italic">{value}</span>
            </div>,
            <div className="flex items-center gap-1 text-sm italic">
                <span className="text-color-500">{`${t(label)} : `}</span>
                <span className="font-bold text-color-100">{value}</span>
            </div>
        )}
    </Translate>
)

const OwnerInformation = ({item}) => {
    const t = useTranslate()
    const {org_type} = item ?? {}
    const {org_types} = useAppConfig()
    const type = _.get(org_types, org_type)

    return (
        <div style={{marginLeft: 4}} className="flex flex-col gap-1">
        <span className="flex items-center gap-3">
            <GoDotFill size={12} className="text-color-400"/>
            <span className="text-sm text-color-500 whitespace-no-wrap italic">
                {`${t('organization by')} : `}
            </span>
        </span>
            <div className="ml-4 flex items-center gap-3">
                <Avatar
                    size={40}
                    src={getAvatar(item)}
                    className="flex flex-center background-200 border border-color-50 rounded-md"
                    icon={<BiSolidChurch size={20} className="text-color-500"/>}
                />
                <div className="flex flex-col flex-1">
                    <Link
                        to={getLinkToDetail(item)}
                        className="font-semibold text-sm text-color-000 truncate no-underline">
                        {getTitle(item)}
                    </Link>
                    {renderIf(
                        type,
                        <div className="font-medium text-xs text-blue-500 italic leading-snug">
                            {t(type)}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

const CourseInfoTab = () => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const {item, renderWarnings = NullAsDefault} = useContext(CourseContext)
    const {medal, about, description, time_open, time_close, last_enrollment_time, academic_field, academic_year} = item ?? {}

    const warnings = Array.from(item?.warnings ?? [])

    const is_visitor = warnings.length

    const countDownFormat = !!isSm
        ? `D ${t('days')} HH:mm:ss`
        : `D [${t('days')}] H [${t('hours')}] m [${t('minutes')}] s [${t('seconds')}]`

    if (is_visitor) {
        return (
            <div className="w-full flex flex-col gap-3">
                {renderWarnings(warnings)}
            </div>
        )
    }

    return renderIf(
        item,
        <div className="px-2 w-full flex flex-col space-y-6">
            <div className="flex flex-col mt-3">
                <div className="flex items-center gap-3">
                    <GiIronCross size={16} className="text-primary"/>
                    <h1 className="font-bold text-lg text-primary uppercase">
                        {getTitle(item)}
                    </h1>
                </div>
                {renderIf(
                    description,
                    <div className="text-xs text-color-500 italic ml-7 mb-4 italic">
                        {description}
                    </div>
                )}
                <div className="ml-0 md:ml-4 mt-2 flex flex-col gap-2">
                    {renderIf(
                        _.some([academic_field, academic_year]),
                        <span style={{padding: '2px 8px', fontSize: '0.7rem', borderRadius: 999, wordBreak: 'break-word', overflowWrap: 'break-word'}}
                              className="w-fit border border-primary-300 font-medium text-primary-600 italic leading-tight max-lines-1">
                          {renderIfElse(
                              academic_field && academic_year,
                              `${academic_field} - ${academic_year}`,
                              academic_field || academic_year
                          )}
                      </span>
                    )}
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                        <div className="flex flex-col gap-3 col-span-1 md:col-span-3 11111">
                            <OwnerInformation item={item?.owner}/>
                            {renderIf(
                                _.some([time_open, last_enrollment_time]),
                                <div style={{marginLeft: 3}} className="flex flex-col gap-2">
                                    {renderIf(
                                        _.some([time_open, time_close]),
                                        <div className="flex items-center gap-2 text-sm">
                                          <span className="flex items-center gap-3">
                                              <GoDotFill size={12} className="text-color-400"/>
                                              <span className="text-color-500 whitespace-no-wrap italic">
                                                  {`${t(isSm ? 'time' : 'scheduled time')} : `}
                                              </span>
                                          </span>
                                            {renderIf(
                                                _.some([time_open, time_close]),
                                                <DoubleValueItem
                                                    primary={true}
                                                    labelFirst=""
                                                    valueFirst={formatDate(time_open, 'DD/MM/YYYY')}
                                                    labelSecond={time_close ? ' - ' : ''}
                                                    valueSecond={time_close && formatDate(time_close, 'DD/MM/YYYY')}
                                                    className="text-sm italic leading-tight"
                                                />
                                            )}
                                        </div>
                                    )}
                                    {renderIf(
                                        last_enrollment_time,
                                        <div className="flex items-center gap-2">
                                            <span className="flex items-center gap-3">
                                                <GoDotFill size={12} className="text-color-400"/>
                                                <span className="text-sm text-color-500 whitespace-no-wrap italic">
                                                    {`${t('last enrollment time')} : `}
                                                </span>
                                            </span>
                                            <span className="font-semibold text-color-100 tracking-wide">
                                                {`${t('open until the end of')}: `}
                                                {formatSimplifyDate(last_enrollment_time, 'fullTime')}
                                            </span>
                                            {/*<Countdown*/}
                                            {/*    style={{padding: '4px 10px'}}*/}
                                            {/*    className="custom-ant-countdown-info bg-blue-100 rounded-md leading-tight"*/}
                                            {/*    value={last_enrollment_time}*/}
                                            {/*    format={countDownFormat}*/}
                                            {/*/>*/}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                        {renderIf(
                            medal,
                            <div className="col-span-1">
                                <TooltipApp
                                    classNames={{root: "text-xs leading-tight"}}
                                    title={
                                        <span className="space-x-1 leading-tight">
                                  <span className="italic">{`${t('certification awarded')} : `}</span>
                                  <span className="font-medium">{medal?.title}</span>
                                </span>
                                    }>
                                    <div className="custom-image-banner">
                                        <Image
                                            src={medal?.avatar || ImagePlaceholder}
                                            fallback={ImagePlaceholder}
                                            style={{height: isSm ? 160 : 140}}
                                            className="object-cover rounded-lg"
                                            wrapperClassName="w-full rounded-lg"
                                            preview={{
                                                mask: (
                                                    <div className="w-full h-full relative">
                                                        <HiViewfinderCircle
                                                            size={16}
                                                            style={{top: 10, right: 10}}
                                                            className="absolute text-white opacity-85 hover:opacity-100 custom-img-view-icon"
                                                        />
                                                    </div>
                                                ),
                                            }}
                                        />
                                    </div>
                                </TooltipApp>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {!isRawContentEmpty(about) && (
                <div className="flex flex-col gap-1">
                    <HeaderWithIconLine
                        icon={<BsInfoCircle size={18} className="text-color-500"/>}
                        title="about course"
                        className="text-lg text-color-400"
                    />
                    <CustomEditorRenderer
                        rawValue={about}
                        className="border-transparent ml-2 text-sm"
                    />
                </div>
            )}
            <CourseSubjectTab/>
            {renderElse(is_visitor, <CourseClassTab/>)}
            <div className="flex flex-col items-center py-6 mt-3 w-full border border-color-50 background-50 rounded-xl">
                <div
                    onClick={() => {copyLink(getAbsoluteLinkToDetail(item))}}
                    className="flex flex-center gap-1 text-blue-500 hover:text-blue-600 cursor-pointer">
                    <span className="flex-1 font-semibold italic">
                        {truncateMiddle(getAbsoluteLinkToDetail(item), isSm ? 36 : 60)}
                    </span>
                    <IoIosCopy size={16}/>
                </div>
                <div
                    className="mt-3 mb-1 text-color-200">{t('access page by scanning the QR code')}</div>
                <QRComponent encode={getAbsoluteLinkToDetail(item)}/>
            </div>
            <div className="h-16"/>
        </div>
    )
}

export default CourseInfoTab
